"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateProfileData = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var user_1 = require("../user");
var useUpdateProfileData = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.successAction, successAction = _f === void 0 ? function () { } : _f, _g = _a.errorAction, errorAction = _g === void 0 ? function (err) { } : _g;
    var data = (0, user_1.useUser)().data;
    var _h = (0, useMutation_1.useMutation)({
        keysUpdate: [keys_1.USER],
        successAction: successAction,
        errorAction: function (err) {
            var _a;
            errorAction === null || errorAction === void 0 ? void 0 : errorAction((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data);
        },
        path: keys_1.UPDATE_PROFILE_DATA,
    }), mutate = _h.mutate, isSubmitting = _h.isSubmitting, error = _h.error;
    var updateProfileHandler = (0, react_1.useCallback)(function (args) {
        var _a, _b, _c, _d;
        if (args === void 0) { args = { phone: undefined }; }
        var existedPhone = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.phone;
        var phone = args.phone, payload = __rest(args, ["phone"]);
        return mutate(existedPhone && phone === existedPhone ? payload : args);
    }, [mutate, (_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.contacts) === null || _e === void 0 ? void 0 : _e.phone]);
    return (0, react_1.useMemo)(function () { return ({
        updateProfile: updateProfileHandler,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [updateProfileHandler, isSubmitting, error]);
};
exports.useUpdateProfileData = useUpdateProfileData;
